<template>
    <div>
        <v-stepper v-model="stepper">
            <v-stepper-header>
                <v-stepper-step :complete="stepper > 1" step="1"
                    >Settings</v-stepper-step
                >

                <v-divider></v-divider>

                <v-stepper-step :complete="stepper > 2" step="2"
                    >Recipients</v-stepper-step
                >

                <v-divider></v-divider>

                <v-stepper-step :complete="stepper > 3" step="3">{{
                    broadcastType == "TEXT" ? "Message" : "Audio"
                }}</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="4">Confirmation</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content step="1">
                    <!-- <v-radio-group
                        v-model="recipientsMode"
                        row
                        class="ml-0 mb-3 pt-0 mt-0"
                        hide-details
                        @change=""
                    >
                        <v-radio
                            class="py-2 pr-2"
                            label="Parents"
                            value="parents"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="py-2 pr-2"
                            label="Staff"
                            value="staff"
                            color="success"
                        ></v-radio>
                    </v-radio-group> -->
                    <v-layout row class="mx-0">
                        <v-select
                            class="pl-0 pr-3 mb-1"
                            style="max-width: 300px"
                            :items="broadcastTypes"
                            label="Broadcast Type"
                            :rules="[rules.required]"
                            ref="broadcastType"
                            v-model="broadcastType"
                            @change="broadcastTypeChanged"
                        ></v-select>
                        <v-radio-group
                            v-model="source"
                            v-if="recipientsMode == 'parents'"
                            row
                            class="mt-0 pt-0"
                            hide-details
                            @change="sourceChanged"
                        >
                            <v-radio
                                class="py-2 pr-2"
                                label="Tuition"
                                value="tuition"
                                color="success"
                            ></v-radio>
                            <v-radio
                                class="py-2 pr-2"
                                label="Dinner"
                                value="dinner"
                                color="success"
                            ></v-radio>
                        </v-radio-group>
                    </v-layout>
                    <v-layout row class="mx-0 time-list">
                        <v-switch
                            color="success"
                            class="mt-2 mr-3 width-180"
                            v-model="isSchedule"
                            label="Schedule For Later"
                        ></v-switch>
                        <!-- <div class="font-weight-regular mr-2 pt-3 width-120">
                            Broadcast Time:
                        </div> -->
                        <v-menu
                            v-model="datePickerMenu"
                            v-if="isSchedule"
                            :close-on-content-click="true"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="broadcastDate"
                                    label="Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                    class="width-150 mr-2 mt-0"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="broadcastDate"
                                :min="today"
                            ></v-date-picker>
                        </v-menu>
                        <DxDateBox
                            style="height: 45px; max-width: 150px"
                            type="time"
                            v-if="isSchedule"
                            picker-type="list"
                            :interval="15"
                            ref="broadcastTime"
                            v-model="broadcastTime"
                        />
                    </v-layout>

                    <v-select
                        v-if="broadcastType == 'CALL'"
                        class="pr-2 mr-1"
                        style="max-width: 300px"
                        :items="['PLIVO', 'TWILIO']"
                        label="Carrier"
                        ref="carrier"
                        v-model="carrier"
                        @change="carrierChanged"
                    ></v-select>

                    <v-layout row class="mx-0">
                        <v-text-field
                            class=""
                            label="Broadcast Name"
                            v-model="callName"
                            ref="callName"
                            style="max-width: 287px"
                            :rules="[rules.required]"
                        ></v-text-field>
                        <v-select
                            v-if="broadcastType == 'CALL'"
                            class="pl-3"
                            style="max-width: 300px"
                            :items="callSpeeds"
                            label="Calls Per Minute"
                            :rules="[rules.required]"
                            ref="callSpeed"
                            v-model="callSpeed"
                        ></v-select>
                        <v-switch
                            color="success"
                            class="mt-4 ml-4"
                            v-model="shouldMerge"
                            label="Merge"
                        ></v-switch>
                    </v-layout>
                    <v-layout
                        row
                        v-if="broadcastType == 'CALL' && shouldMerge"
                        class="mx-0 mb-3"
                    >
                        <v-radio-group
                            v-model="mergeType"
                            row
                            class="mt-0 pt-0"
                            hide-details
                        >
                            <v-radio
                                class="pb-2 pr-2"
                                label="Merge From File"
                                value="file"
                                color="success"
                            ></v-radio>
                            <v-radio
                                class="pb-2 pr-2"
                                label="Merge Account Info"
                                value="account"
                                color="success"
                            ></v-radio>
                        </v-radio-group>
                    </v-layout>
                    <v-layout row class="mx-0 mt-2 mb-2">
                        <v-autocomplete
                            style="max-width: 300px"
                            class="mt-3 pt-0 pl-0 pr-3"
                            label="Select Caller ID"
                            hide-no-data
                            ref="fromNumberSelect"
                            v-model="from"
                            item-text="displayNumber"
                            :items="getNumberList()"
                            :search-input.sync="loadPhoneNumbers"
                            :loading="loadingNumbers"
                            @change="fromNumberChanged"
                            return-object
                        ></v-autocomplete>
                        <v-radio-group
                            v-if="broadcastType == 'TEXT' && shouldMerge"
                            v-model="mergeType"
                            row
                            class="ml-3 mt-0"
                            hide-details
                        >
                            <v-radio
                                class="py-2 pr-2"
                                label="Merge From File"
                                value="file"
                                color="success"
                            ></v-radio>
                            <v-radio
                                class="py-2 pr-2"
                                label="Merge Account Info"
                                value="account"
                                color="success"
                            ></v-radio>
                        </v-radio-group>
                        <div v-if="broadcastType == 'CALL'" class="pt-4 pr-3">
                            OR
                        </div>
                        <v-text-field
                            v-if="broadcastType == 'CALL'"
                            label="Manually Enter Caller ID"
                            v-model="fromNumber"
                            ref="fromNumberText"
                            @input="fromNumberTextChanged"
                            style="max-width: 300px"
                            :rules="[rules.required, rules.phoneNumber]"
                        ></v-text-field>
                    </v-layout>

                    <div v-if="broadcastType == 'CALL'">
                        <v-checkbox
                            color="success"
                            class="my-0"
                            v-model="shouldTransfer"
                            label="Transfer number when pressing 0"
                            hide-details
                        ></v-checkbox>

                        <v-layout
                            row
                            class="mx-0 mt-2 mb-2"
                            v-if="shouldTransfer"
                        >
                            <v-autocomplete
                                style="max-width: 300px"
                                class="mt-3 pt-0 pl-0 pr-3"
                                label="Select Transfer Number"
                                hide-no-data
                                ref="transferNumberSelect"
                                v-model="transferNumberSelect"
                                item-text="displayNumber"
                                :items="transferNumbers"
                                :search-input.sync="loadTransferNumbers"
                                :loading="loadingTransferNumbers"
                                @change="transferNumberChanged"
                                return-object
                            ></v-autocomplete>
                            <div class="pt-4 pr-3">OR</div>
                            <v-text-field
                                label="Manually Enter Transfer Number"
                                v-model="transferNumber"
                                ref="transferNumberText"
                                :rules="[rules.phoneNumber]"
                                @input="transferNumberTextChanged"
                                style="max-width: 287px"
                            ></v-text-field>
                        </v-layout>
                    </div>

                    <v-card-actions class="pr-0">
                        <v-spacer></v-spacer>
                        <v-btn color="default" dark @click="close()">
                            Cancel
                        </v-btn>
                        <v-btn color="success" outline @click="saveDraft()">
                            Save Draft
                        </v-btn>
                        <v-btn color="success" @click="continueToRecipients">
                            Continue
                        </v-btn>
                    </v-card-actions>
                </v-stepper-content>
                <v-stepper-content step="2">
                    <v-layout row justify-center class="mb-3">
                        <v-btn
                            small
                            color="success"
                            v-if="recipientsMode == 'parents'"
                            outline
                            :disabled="disableChooseNumberAction('studentList')"
                            @click="openChooseNumberDialog('studentList')"
                            >Choose From List</v-btn
                        >
                        <v-btn
                            small
                            color="success"
                            v-if="recipientsMode == 'staff'"
                            outline
                            :disabled="disableChooseNumberAction('staffList')"
                            @click="openChooseNumberDialog('staffList')"
                            >Choose From List</v-btn
                        >
                        <v-btn
                            small
                            color="success"
                            outline
                            @click="openChooseNumberDialog('uploadFromFile')"
                            :disabled="
                                disableChooseNumberAction('uploadFromFile')
                            "
                            >Upload From File</v-btn
                        >
                        <v-btn
                            small
                            color="success"
                            outline
                            @click="openChooseNumberDialog('manualEntry')"
                            :disabled="disableChooseNumberAction('manualEntry')"
                            >Manually Add Numbers</v-btn
                        >
                        <v-btn
                            small
                            color="success"
                            outline
                            @click="openChooseNumberDialog('importAccounts')"
                            :disabled="
                                disableChooseNumberAction('importAccounts')
                            "
                            v-if="recipientsMode == 'parents'"
                            >Import Accounts</v-btn
                        >
                    </v-layout>
                    <v-layout row class="mb-3">
                        <div class="font-weight-medium mr-2 mt-2 title">
                            Numbers ({{ numbers.length }})
                        </div>
                        <v-btn
                            class="mb-2 mt-0"
                            @click="clearNumbers"
                            small
                            color="success"
                            ><v-icon dark left>mdi-close-circle</v-icon>Delete
                            Selected</v-btn
                        >
                    </v-layout>
                    <v-layout row>
                        <!-- <div style="max-width: 40px;">
                            <v-checkbox
                                class="mt-0 pt-0 pr-3"
                                style="max-width: 40px;"
                                v-model="allNumbersSelected"
                                color="success"
                                hide-details
                            ></v-checkbox>
                        </div> -->
                        <div class="font-weight-regular width-250">Number</div>
                        <div class="font-weight-regular width-250">
                            {{
                                recipientsMode == "parents"
                                    ? "Account ID"
                                    : "Teacher Code"
                            }}
                        </div>
                        <div class="font-weight-regular width-300">Name</div>
                        <div class="font-weight-regular">Hebrew Name</div>
                    </v-layout>
                    <v-divider class="mb-2"></v-divider>
                    <div>
                        <div v-for="(number, index) in numbersToDisplay">
                            <v-layout row>
                                <!-- <v-checkbox
                                    class="mt-0 pt-0"
                                    style="max-width: 40px;"
                                    v-model="number.selected"
                                    color="success"
                                    hide-details
                                ></v-checkbox> -->
                                <div class="width-250">
                                    {{ number.number | phone }}
                                </div>
                                <div
                                    class="width-250"
                                    v-if="recipientsMode == 'parents'"
                                >
                                    {{
                                        number.accountID
                                            ? number.accountID
                                            : number.personID
                                    }}
                                </div>
                                <div
                                    class="width-250"
                                    v-if="recipientsMode == 'staff'"
                                >
                                    {{ number.teacherCode }}
                                </div>
                                <div class="width-300">{{ number.name }}</div>
                                <div>{{ number.nameH }}</div>
                            </v-layout>
                            <v-divider
                                class="mb-2"
                                v-if="index + 1 < numbers.length"
                            ></v-divider>
                        </div>
                    </div>
                    <v-layout justify-center class="mt-3 mb-1">
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="5"
                            v-on:input="setPagianation"
                        ></v-pagination>
                    </v-layout>
                    <v-card-actions class="pr-0 mt-2">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="confirmCloseDialog = true"
                        >
                            Cancel
                        </v-btn>
                        <v-btn outline @click="stepper = 1">
                            Back
                        </v-btn>
                        <v-btn color="success" outline @click="saveDraft()">
                            Save Draft
                        </v-btn>
                        <v-btn color="success" @click="continueToAudio()">
                            Continue
                        </v-btn>
                    </v-card-actions>
                </v-stepper-content>
                <v-stepper-content step="3">
                    <div v-if="broadcastType == 'CALL' && !shouldMerge">
                        <v-layout row class="mx-2 mb-2">
                            <div
                                style="border: 2px solid rgb(76, 175, 80); border-radius: 5px;"
                                class="pa-2 font-weight-regular"
                            >
                                Call<span class="mx-1 font-weight-medium"
                                    >646-349-1934</span
                                >
                                Pin#<span class="mx-1 font-weight-medium"
                                    >1234</span
                                >
                                to record your audio
                            </div>
                        </v-layout>
                        <v-layout
                            row
                            v-if="audioFile && broadcastType == 'CALL'"
                            class="ml-3 mt-3"
                        >
                            <div class="font-weight-medium mr-3 pt-3">
                                Selected File:
                            </div>
                            <audio controls :src="audioFile"></audio>
                        </v-layout>
                        <v-layout class="mx-3 mt-3" row>
                            <div
                                style=""
                                class="pt-3 text-xs-center font-weight-medium title"
                            >
                                Click the audio file you want
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn
                                :disabeld="loadingAudio"
                                small
                                color="success"
                                :loading="uploading"
                                @click="pickFile()"
                                ><v-icon dark left>mdi-cloud-upload</v-icon
                                >Upload</v-btn
                            >
                            <input
                                type="file"
                                style="display: none"
                                ref="files"
                                accept=".mp3, .wav"
                                @change="onFilePicked($event)"
                            />
                            <v-btn
                                @click="loadAudioLibrary"
                                :disabeld="loadingAudio"
                                small
                                color="success"
                                ><v-icon dark left>mdi-reload</v-icon>Reload
                                Library</v-btn
                            >
                        </v-layout>

                        <div
                            style="height: 420px; overflow-y: auto;"
                            class="mx-3 mb-3"
                        >
                            <v-layout
                                row
                                class="pa-2 mb-2"
                                v-for="(audio, index) in audioLibrary"
                                @click="selectAudio(audio)"
                                style="cursor: pointer; border: 1px solid #4caf50; border-radius: 4px"
                            >
                                <v-checkbox
                                    v-model="audio.selected"
                                    color="success"
                                    class="ml-2 mt-2 pt-2 pr-3"
                                    hide-details
                                ></v-checkbox>
                                <div
                                    style="width: 20%"
                                    class="pt-3 font-weight-regular"
                                >
                                    {{ audio.date | time }}
                                </div>
                                <v-layout justify-center style="width: 30%">
                                    <div
                                        v-if="!audio.editing"
                                        class="pt-3 font-weight-regular"
                                    >
                                        {{ audio.name }}
                                    </div>
                                    <v-btn
                                        class="my-0 pt-2"
                                        v-if="!audio.editing"
                                        @click.stop="editAudio(audio)"
                                        flat
                                        icon
                                        color="success"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-text-field
                                        style="width: 30%"
                                        class="pr-0 my-0 mr-3"
                                        hide-details
                                        v-if="audio.editing"
                                        label="Name"
                                        v-model="audio.name"
                                    ></v-text-field>
                                    <v-btn
                                        class=""
                                        v-if="audio.editing"
                                        small
                                        dark
                                        @click.stop="cancelAudioName(audio)"
                                        color="default"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        class="mr-3"
                                        v-if="audio.editing"
                                        small
                                        @click.stop="saveAudioName(audio)"
                                        color="success"
                                    >
                                        Save
                                    </v-btn>
                                </v-layout>

                                <div style="width: 20%" class="pt-3">
                                    <span class="font-weight-regular mr-1"
                                        >From:</span
                                    >
                                    <span
                                        v-if="audio.callerID != 'ADMIN PORTAL'"
                                        >{{ audio.callerID | phone }}</span
                                    >
                                    <span v-else>{{ audio.callerID }}</span>
                                </div>
                                <div style="width: 10%" class="pt-3">
                                    <span
                                        v-if="audio.branch"
                                        class="font-weight-regular mr-1"
                                        >Branch:</span
                                    >
                                    <span v-if="audio.branch">{{
                                        audio.branch
                                    }}</span>
                                </div>
                                <audio
                                    controls
                                    :src="audio.recordingURL"
                                ></audio>
                                <v-btn
                                    class="my-0 pt-2"
                                    @click.stop="openDeleteAudioDialog(audio)"
                                    flat
                                    icon
                                    color="success"
                                >
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-layout>
                        </div>
                    </div>
                    <div v-if="broadcastType == 'CALL' && shouldMerge">
                        <div class="headline mb-2">Call Setup</div>
                        <v-divider class="pb-2"></v-divider>
                        <div style="height: 300px; overflow-y: auto;">
                            <div
                                v-for="(instruction,
                                index) in plivoInstructions"
                            >
                                <v-layout row>
                                    <v-select
                                        style="max-width: 120px"
                                        label="Type"
                                        hide-details
                                        class="mr-2"
                                        :items="['Audio', 'Text', 'Data Field']"
                                        v-model="instruction.type"
                                        @change="onTypeChange(instruction)"
                                    ></v-select>

                                    <v-select
                                        label="Data Field"
                                        v-if="instruction.type == 'Data Field'"
                                        class="mr-2"
                                        :items="getMergeFields()"
                                        v-model="instruction.dataField"
                                        ref="dataField"
                                        :rules="[rules.required]"
                                    ></v-select>

                                    <v-text-field
                                        class="mr-2"
                                        v-if="instruction.type == 'Audio'"
                                        label="Audio URL"
                                        v-model="instruction.audioURL"
                                        ref="audioURL"
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                    <audio
                                        controls
                                        v-if="instruction.type == 'Audio'"
                                        style="height: 33px"
                                        class="mt-3"
                                        :src="instruction.audioURL"
                                    ></audio>

                                    <v-textarea
                                        class="pt-0"
                                        v-if="instruction.type == 'Text'"
                                        label="Text"
                                        v-model="instruction.text"
                                        ref="callText"
                                        :rules="[rules.required]"
                                        rows="2"
                                    ></v-textarea>

                                    <v-btn
                                        class="mb-0 mr-3"
                                        v-if="instruction.type == 'Text'"
                                        @click="playText(instruction.text)"
                                        flat
                                        icon
                                        color="info"
                                    >
                                        <v-icon>mdi-play-circle</v-icon>
                                    </v-btn>

                                    <v-btn
                                        class="mb-0"
                                        @click="addInstruction('call', index)"
                                        flat
                                        icon
                                        color="success"
                                    >
                                        <v-icon>mdi-plus-circle</v-icon>
                                    </v-btn>
                                    <v-btn
                                        class="mb-0"
                                        :disabled="index == 0"
                                        @click="
                                            removeInstruction('call', index)
                                        "
                                        flat
                                        icon
                                        color="#f55a4e"
                                    >
                                        <v-icon
                                            >mdi-minus-circle-outline</v-icon
                                        >
                                    </v-btn>
                                </v-layout>
                            </div>
                        </div>
                    </div>
                    <div v-if="broadcastType == 'TEXT'">
                        <v-textarea
                            outline
                            rows="8"
                            v-if="!shouldMerge"
                            label="Message"
                            v-model="message"
                            ref="message"
                            :rules="[rules.required, rules.maxMessageLength]"
                        ></v-textarea>
                        <div v-if="!shouldMerge">
                            <span class="mx-1 font-weight-medium"
                                >Character count:</span
                            >
                            {{ getMessageCount(message) }}
                        </div>
                        <v-layout row v-if="shouldMerge">
                            <div style="width: 70% !important">
                                <v-select
                                    label="Data Field"
                                    class="mr-2 text-xs-right"
                                    :items="getMergeFields()"
                                    @change="onMergeFieldSelected"
                                    clearable
                                ></v-select>
                                <v-textarea
                                    class="mb-0"
                                    outline
                                    rows="10"
                                    label="Message"
                                    v-model="mergeMessage"
                                    ref="mergeMessage"
                                    :rules="[
                                        rules.required,
                                        rules.maxMessageLength,
                                    ]"
                                ></v-textarea>
                                <div>
                                    <span class="mx-1 font-weight-medium"
                                        >Character count:</span
                                    >
                                    {{ getMessageCount(mergeMessage) }}
                                </div>
                            </div>
                            <div
                                class="mb-0 ml-2"
                                style="width: 30% !important"
                            >
                                <div class="headline mx-2 mb-2">
                                    Sample Text
                                </div>
                                <div class="px-3 pb-3 ml-2 merge-text" style="">
                                    {{ getMergedText(numbers[mergeTextIndex]) }}
                                </div>
                                <v-layout class="ml-2 mb-0 pb-0" row>
                                    <v-btn
                                        color="success"
                                        class="mb-0"
                                        small
                                        v-if="showMergeTextButton('previous')"
                                        @click="
                                            updateMergeSampleText('previous')
                                        "
                                        >Previous</v-btn
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="success"
                                        small
                                        class="mb-0"
                                        v-if="showMergeTextButton('next')"
                                        @click="updateMergeSampleText('next')"
                                        >Next</v-btn
                                    >
                                </v-layout>
                            </div>
                        </v-layout>
                    </div>
                    <v-card-actions class="pr-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="confirmCloseDialog = true"
                        >
                            Cancel
                        </v-btn>
                        <v-btn outline @click="stepper = 2">
                            Back
                        </v-btn>
                        <v-btn color="success" outline @click="saveDraft()">
                            Save Draft
                        </v-btn>
                        <v-btn color="success" @click="continueToReview">
                            Continue
                        </v-btn>
                    </v-card-actions>
                </v-stepper-content>
                <v-stepper-content step="4">
                    <div
                        style=""
                        class="pt-3 text-xs-center font-weight-medium title"
                    >
                        Please Review
                    </div>
                    <v-layout row justify-space-between align-end>
                        <div>
                            <v-layout row class="px-3 py-2">
                                <div class="font-weight-medium mr-2 width-200">
                                    Broadcast Name:
                                </div>
                                <div>
                                    {{ callName }}
                                </div>
                            </v-layout>
                            <v-layout row class="px-3 py-2" v-if="isSchedule">
                                <div class="font-weight-medium mr-2 width-200">
                                    Broadcast Time:
                                </div>
                                <div>
                                    {{ getBroadcastTime() | time }}
                                </div>
                            </v-layout>
                            <v-layout row class="px-3 py-2">
                                <div class="font-weight-medium mr-2 width-200">
                                    Caller ID:
                                </div>
                                <div>
                                    {{ fromNumber | phone }}
                                </div>
                            </v-layout>
                            <v-layout
                                row
                                class="px-3 py-2"
                                v-if="transferNumber && broadcastType == 'CALL'"
                            >
                                <div class="font-weight-medium mr-2 width-200">
                                    Transfer number:
                                </div>
                                <div>
                                    {{ transferNumber | phone }}
                                </div>
                            </v-layout>
                            <v-layout row class="px-3 py-2">
                                <div class="font-weight-medium mr-2 width-200">
                                    Broadcast Type:
                                </div>
                                <div>
                                    {{ broadcastType }}
                                </div>
                            </v-layout>
                            <div v-if="selectNumberMode == 'studentList'">
                                <v-layout
                                    row
                                    class="px-3 py-2"
                                    v-if="branch.length"
                                >
                                    <div
                                        class="font-weight-medium mr-2 width-200"
                                    >
                                        Branches:
                                    </div>
                                    <div>
                                        {{ branch.join(", ") }}
                                    </div>
                                </v-layout>
                                <v-layout
                                    row
                                    class="px-3 py-2"
                                    v-if="grade.length"
                                >
                                    <div
                                        class="font-weight-medium mr-2 width-200"
                                    >
                                        Grades:
                                    </div>
                                    <div>
                                        {{ grade.join(", ") }}
                                    </div>
                                </v-layout>
                                <!-- <v-layout row class="px-3 py-2">
                                    <div
                                        class="font-weight-medium mr-2 width-200"
                                    >
                                        Total Parents:
                                    </div>
                                    <div>
                                        {{ parentCount }}
                                    </div>
                                </v-layout> -->
                                <v-layout row class="px-3 py-2">
                                    <div
                                        class="font-weight-medium mr-2 width-200"
                                    >
                                        Total
                                        {{
                                            broadcastType == "TEXT"
                                                ? "Messages"
                                                : "Calls"
                                        }}:
                                    </div>
                                    <div>
                                        {{ getTotalCalls() }}
                                    </div>
                                </v-layout>
                                <v-layout row class="px-3 py-2">
                                    <div
                                        class="font-weight-medium mr-2 width-200"
                                    >
                                        Phone Type:
                                    </div>
                                    <div>
                                        {{ phoneTypes.join(",") }}
                                    </div>
                                </v-layout>
                            </div>
                            <div v-else>
                                <v-layout row class="px-3 py-2">
                                    <div
                                        class="font-weight-medium mr-2 width-200"
                                    >
                                        Total Numbers:
                                    </div>
                                    <div>
                                        {{ getTotalCalls() }}
                                    </div>
                                </v-layout>
                            </div>
                            <v-layout
                                row
                                class="px-3 py-2"
                                v-if="audioFile && broadcastType == 'CALL'"
                            >
                                <div class="font-weight-medium mr-2 width-200">
                                    Selected File:
                                </div>
                                <audio
                                    controls
                                    :src="audioFile"
                                    style="width: 323px;"
                                ></audio>
                            </v-layout>
                            <v-layout
                                row
                                class="px-3 py-2"
                                v-if="message && broadcastType == 'TEXT'"
                            >
                                <div class="font-weight-medium mr-2 width-200">
                                    Message:
                                </div>
                                <div style="width: 60%">
                                    {{ message }}
                                </div>
                            </v-layout>
                        </div>
                        <v-layout class="mb-0" row justify-end>
                            <v-text-field
                                v-model="testNumber"
                                class="mx-2"
                                style="max-width: 150px; min-width: 150px;"
                                label="Test Number"
                                ref="testNumber"
                                :rules="[rules.phoneNumber]"
                            ></v-text-field>
                            <v-btn
                                :disabled="!testNumber"
                                color="success"
                                class="mt-3 mb-0"
                                style="height: 28px;"
                                small
                                @click="send(true)"
                                >{{
                                    broadcastType == "TEXT"
                                        ? "Send Text Message"
                                        : "Send Test Call"
                                }}</v-btn
                            >
                        </v-layout>
                    </v-layout>
                    <v-card-actions class="pr-0 mt-2">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            @click="confirmCloseDialog = true"
                        >
                            Cancel
                        </v-btn>
                        <v-btn outline @click="stepper = 3">
                            Back
                        </v-btn>
                        <v-btn
                            :loading="sending"
                            color="success"
                            @click="send()"
                        >
                            Send
                        </v-btn>
                    </v-card-actions>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>

        <v-dialog persistent v-model="deleteAudioDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Are You Sure?</v-card-title
                >
                <v-card-text class="mb-3 py-0">
                    You will now delete {{ audioToDelete.name }} audio file
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteAudioDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        :loading="deleting"
                        color="success"
                        @click="deleteAudio()"
                        >Delete</v-btn
                    >
                </v-card-actions>
                <div
                    class="font-weight-light text-xs-center"
                    style="color: #00d3ee"
                >
                    {{ processingMessages }}
                </div>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="chooseNumbersDialog" max-width="1200">
            <v-card class="pa-3">
                <v-layout
                    row
                    class="mt-2"
                    v-if="selectNumberMode == 'studentList'"
                >
                    <v-select
                        class="pl-0 pr-3 mb-1"
                        style="max-width: 250px"
                        :items="branchList"
                        label="Branch"
                        :rules="[rules.required]"
                        ref="branch"
                        multiple
                        v-model="branch"
                        @change="branchChanged"
                        clearable
                        :disabled="disableBranch()"
                    ></v-select>
                    <v-select
                        v-if="branch"
                        class="pr-3 mb-1"
                        style="max-width: 250px"
                        :items="gradeList"
                        label="Grade"
                        multiple
                        ref="grade"
                        v-model="grade"
                        @change="gradesChanged"
                        clearable
                    ></v-select>
                    <v-select
                        class="pr-3 mb-1"
                        style="max-width: 150px"
                        :items="terms"
                        label="Term"
                        ref="term"
                        v-model="regID"
                        @change="termsChanged"
                    ></v-select>
                    <v-select
                        class="pl-0 mb-1"
                        style="max-width: 300px"
                        :items="getPhoneTypes()"
                        label="Phone Type"
                        multiple
                        :rules="[rules.required]"
                        ref="broadcastCallPhoneTypes"
                        v-model="phoneTypes"
                    ></v-select>
                    <v-layout row class="ml-3 pt-4">
                        <v-layout row v-for="type in phoneTypes">
                            <div class="font-weight-medium mr-2">
                                {{ type }}:
                            </div>
                            <div class="font-weight-light">
                                {{ numbersCount[type.toLowerCase()] }}
                            </div>
                        </v-layout>
                    </v-layout>
                </v-layout>
                <v-flex
                    xs12
                    class="px-0 pb-0 xs4 pt-0 scroll"
                    style="height: 500px; overflow-y: auto;"
                    ><div v-if="selectNumberMode == 'studentList'">
                        <v-tabs v-model="studentListTab" hide-slider>
                            <v-tabs-slider color="success"></v-tabs-slider>
                            <v-tab
                                href="#students"
                                v-bind:class="{
                                    'selected-tab':
                                        studentListTab == 'students',
                                }"
                                >{{ getStudentsTitle() }}</v-tab
                            >
                            <v-tab
                                href="#parents"
                                v-bind:class="{
                                    'selected-tab': studentListTab == 'parents',
                                }"
                                >{{ getParentsTitle() }}</v-tab
                            >
                        </v-tabs>
                        <v-tabs-items v-model="studentListTab">
                            <v-tab-item value="students">
                                <data-grid
                                    class="simple-datagrid"
                                    :url="studentUrl"
                                    :columns="studentColumns"
                                    title="Students"
                                    ref="grid"
                                    :hideHeader="true"
                                    :hideActions="true"
                                    :selectionEnabled="false"
                                    :perPage="7"
                                    :beforeSetupGrid="beforeSetupGrid"
                                    :onLoaded="onStudentsLoaded"
                                    :sortOptions="{
                                        enabled: true,
                                        field: 'lastName',
                                        type: 'asc',
                                    }"
                                ></data-grid>
                            </v-tab-item>
                            <v-tab-item value="parents">
                                <data-grid
                                    v-if="showParentsTable"
                                    class="simple-datagrid"
                                    :url="studentUrl"
                                    name="parents-list"
                                    :columns="parentColumns"
                                    title="Students"
                                    ref="parentGrid"
                                    :hideHeader="true"
                                    :hideActions="true"
                                    :selectionEnabled="false"
                                    :perPage="20"
                                    :mapper="studentListMapper"
                                    :sortOptions="{
                                        enabled: true,
                                        field: 'lastName',
                                        type: 'asc',
                                    }"
                                ></data-grid>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                    <div v-if="selectNumberMode == 'staffList'">
                        <v-select
                            class="pl-0 pr-3 mb-1"
                            style="max-width: 300px"
                            :items="branchList"
                            label="Branch"
                            :rules="[rules.required]"
                            ref="branch"
                            multiple
                            v-model="staffBranch"
                            @change="staffBranchChanged"
                            clearable
                            :disabled="disableBranch()"
                        ></v-select>
                        <data-grid
                            class="simple-datagrid"
                            :url="staffUrl"
                            name="parents-list"
                            :columns="staffColumns"
                            title="Staff"
                            ref="staffGrid"
                            :hideHeader="true"
                            :hideActions="true"
                            :selectionEnabled="false"
                            :beforeSetupGrid="beforeSetupGrid"
                            :perPage="20"
                        ></data-grid>
                    </div>
                    <div
                        v-if="selectNumberMode == 'manualEntry'"
                        class="mt-3"
                        style="height: 500px; overflow-y: auto;"
                    >
                        <v-layout row v-for="(number, index) in manualNumbers">
                            <v-text-field
                                class="px-1 mr-2"
                                label="Number"
                                v-model="number.number"
                                ref="manualNumber"
                            ></v-text-field>
                            <v-text-field
                                class="px-1 mx-2"
                                label="Account ID"
                                v-model="number.accountID"
                            ></v-text-field>
                            <v-btn @click="addNumber" flat icon color="success">
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn
                                :disabled="index == 0"
                                @click="removeNumber(index)"
                                flat
                                icon
                                color="#f55a4e"
                            >
                                <v-icon>mdi-minus-circle-outline</v-icon>
                            </v-btn>
                        </v-layout>
                    </div>
                    <div v-if="selectNumberMode == 'uploadFromFile'">
                        <v-layout row class="mt-3">
                            <v-layout column class="" style="width: 46%;">
                                <div class="subheading font-weight-medium mb-2">
                                    Instructions
                                </div>
                                <ul class="body-1" v-if="!isMergingFromFile()">
                                    <li>
                                        File should be in CSV format.
                                    </li>
                                    <li>
                                        Column Configration: A. Account ID
                                        (Optional), B. Phone Number (Required),
                                        C. Phone Number (Optional), D. Phone
                                        Number (Optional), E. Phone Number
                                        (Optional)
                                    </li>
                                </ul>
                                <ul class="body-1" v-if="isMergingFromFile()">
                                    <li>
                                        File should be in .xlsx format.
                                    </li>
                                    <li>
                                        Column Configration: A. Account ID
                                        (Required), B. Phone Number (Required),
                                        C. Label 1 (Required), D. E. F. ...Label
                                        (Optional)
                                    </li>
                                </ul>
                            </v-layout>
                            <v-spacer></v-spacer>
                            <v-btn
                                small
                                style="width: 150px; height: 34px;"
                                color="blue-grey"
                                class="white--text mt-0"
                                :loading="uploadingNumbers"
                                @click="pickNumbersFile()"
                            >
                                <v-icon left dark>mdi-cloud-upload</v-icon>
                                Upload Numbers
                            </v-btn>
                            <input
                                type="file"
                                style="display: none"
                                ref="numbersFile"
                                accept=".csv, .xlsx, .xls"
                                @input="onNumbersFilePicked($event)"
                                onclick="this.value = null"
                            />
                        </v-layout>
                        <v-divider class="mt-2"></v-divider>
                        <vue-good-table
                            v-if="toNumbers.length"
                            class="number-list"
                            :columns="toNumbersColumns"
                            :rows="toNumbers"
                            :search-options="{
                                enabled: false,
                            }"
                        >
                            <template slot="table-row" slot-scope="props">
                                <v-layout column class="ma-0 pa-0">
                                    <span>
                                        {{
                                            props.formattedRow[
                                                props.column.field
                                            ]
                                        }}
                                    </span>
                                    <span
                                        class="text-danger pa-0 ma-0"
                                        style="font-size: 11px;"
                                        v-if="
                                            getError(
                                                props.row,
                                                props.column.field,
                                            )
                                        "
                                    >
                                        {{
                                            getError(
                                                props.row,
                                                props.column.field,
                                            )
                                        }}
                                    </span>
                                </v-layout>
                            </template>
                        </vue-good-table>
                        <div v-if="!to.length && !uploading">
                            <v-container fluid grid-list-md>
                                <v-layout
                                    align-center
                                    justify-center
                                    row
                                    fill-height
                                    class="layout font-weight-light display-2 text--disabled mt-5 text-xs-center"
                                >
                                    Please upload a list of phone
                                    numbers</v-layout
                                >
                            </v-container>
                        </div>
                        <div v-if="uploading">
                            <v-container fluid grid-list-md>
                                <v-layout
                                    align-center
                                    justify-center
                                    row
                                    fill-height
                                    class="mt-5 text-xs-center"
                                >
                                    <v-progress-circular
                                        :size="100"
                                        :width="3"
                                        color="rgba(0,0,0,.38)"
                                        indeterminate
                                    ></v-progress-circular>
                                </v-layout>
                            </v-container>
                        </div>
                    </div>
                    <div v-if="selectNumberMode == 'importAccounts'">
                        <div class="headline mb-3">
                            Please enter a list of Account ID's separated by a
                            comma or new line
                        </div>
                        <v-layout row class="mt-3">
                            <v-textarea
                                style="width: 71%;"
                                outline
                                rows="22"
                                label="Account IDs"
                                v-model="accountIDsText"
                                ref="accountIDsText"
                                @input="accountIDsEnterted"
                                hide-details
                                :rules="[rules.required]"
                            ></v-textarea>
                            <v-layout column>
                                <div class="mx-3 width-300">
                                    <div
                                        class="headline mb-3"
                                        style="border-bottom: 1px solid #999"
                                    >
                                        Account ID's ({{ accountIDs.length }})
                                    </div>
                                    <div
                                        style="overflow-y: auto; height: 330px"
                                    >
                                        <div
                                            v-for="(accountID,
                                            index) in accountIDs"
                                        >
                                            <v-layout row>
                                                <div>{{ accountID }}</div>
                                            </v-layout>
                                            <v-divider
                                                class="mb-2"
                                                v-if="
                                                    index + 1 <
                                                        accountIDs.length
                                                "
                                            ></v-divider>
                                        </div>
                                    </div>
                                </div>
                                <v-select
                                    class="pt-0 mb-1 mx-3"
                                    style="max-width: 300px"
                                    :items="getPhoneTypes()"
                                    label="Phone Type"
                                    multiple
                                    hide-details
                                    outline
                                    :rules="[rules.required]"
                                    ref="broadcastCallPhoneTypes"
                                    v-model="phoneTypes"
                                ></v-select>
                            </v-layout>
                        </v-layout>
                    </div>
                </v-flex>
                <v-card-actions class="">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="chooseNumbersDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="addingNumbers"
                        @click="addNumbers"
                        >Add Numbers</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmCloseDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0">
                    Are you sure?
                </v-card-title>
                <div class="mb-3">You will lose your broadcast setup</div>
                <v-card-actions class="mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="confirmCloseDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" @click="confirmClose()">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import Papa from "papaparse";
import Pusher from "pusher-js";
import DxDateBox from "devextreme-vue/date-box";
import AWS from "aws-sdk";

import {
    getDomain,
    formatPhoneNumber,
    onlyUnique,
    groupBy,
    toTitleCase,
    toISOLocal,
    firstToLower,
    except,
} from "../../utils/helpers.js";

export default {
    props: {
        closeDialog: Function,
        openSnakbar: Function,
    },
    components: {
        DxDateBox,
    },
    data: () => ({
        from: "",
        to: [],
        message: "",
        fromNumbers: [],
        fromNumber: "",
        testNumber: "",
        transferNumbers: [],
        transferNumber: "",
        transferNumberSelect: "",
        files: [],
        phoneTypes: [],
        broadcastTypes: ["CALL", "TEXT"],
        callSpeeds: ["5", "20", "50", "100", "200", "MAX"],
        callSpeed: "MAX",
        broadcastType: "CALL",
        recipientsMode: "parents",
        source: "tuition",
        broadcastID: "",
        message: "",
        mergeMessage: "",
        shouldTransfer: "",

        mergeTextIndex: 0,

        shouldMerge: false,
        mergeType: "file",
        carrier: "PLIVO",
        isSchedule: false,
        datePickerMenu: false,
        broadcastTime: new Date(),
        broadcastDate: toISOLocal(new Date(moment())).substr(0, 10),
        today: toISOLocal(new Date(moment())).substr(0, 10),
        plivoInstructions: [],
        awsPolly: "",

        branchList: [],
        branch: [],
        staffBranch: [],

        gradeList: [],
        grade: [],

        regID: "",
        terms: [],

        broadcasts: [],
        broadcastList: [],

        stepper: 0,

        audioFile: "",
        selectedAudio: "",
        callName: "",
        studentListTab: "students",
        studentCount: 0,
        parentCount: 0,
        students: [],
        numbersCount: "",

        manualNumbers: [],

        numbers: [],
        chooseNumbersDialog: false,
        addingNumbers: false,
        confirmCloseDialog: false,

        mergeFiles: [],
        uploading: false,
        uploadingNumbers: false,
        sending: false,

        confirmDialog: false,
        confirmDuplicatesDialog: false,

        audioLibraryDialog: false,
        audioLibrary: [],

        loadPhoneNumbers: null,
        loadingNumbers: false,
        loadTransferPhoneNumbers: null,
        loadingTransferNumbers: false,
        selectNumberMode: "studentList",
        accountIDsText: "",
        showParentsTable: false,

        requestID: "",
        processingMessages: "",
        totalProcessingMessages: "",
        accountIDs: [],

        duplicates: [],
        duplicateCount: 0,

        deleteAudioDialog: false,
        deleting: false,
        audioToDelete: "",

        pagination: {
            totalCount: 0,
            rowsPerPage: 13,
            page: 1,
        },

        rules: {
            required: (value) => !!value || "Required.",
            maxMessageLength: (value) => {
                let count = 0;
                for (let i = 0; i < value.length; i++) {
                    let code = value.charCodeAt(i);
                    if (code < 128) {
                        count++;
                    } else if (code < 2048) {
                        count += 2;
                    } else if (code < 65536) {
                        count += 3;
                    } else {
                        count += 4;
                    }
                }

                return !value || count < 738 || "Max length is 737";
            },
            fromNumber: [
                (value) => {
                    return !!value || "Required.";
                },
            ],
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
        },

        numbersToDisplay: [],

        toNumbers: [],

        toNumbersColumns: [
            {
                sortable: false,
                label: "Account ID",
                field: "accountID",
                width: "125px",
            },
            {
                sortable: false,
                label: "Phone 1",
                field: "phone1",
                width: "125px",
            },
            {
                sortable: false,
                label: "Phone 2",
                field: "phone2",
                width: "125px",
            },
            {
                sortable: false,
                label: "Phone 3",
                field: "phone3",
                width: "125px",
            },
            {
                sortable: false,
                label: "Phone 4",
                field: "phone4",
                width: "125px",
            },
            {
                sortable: false,
                label: "Phone 5",
                field: "phone5",
                width: "125px",
            },
            {
                sortable: false,
                label: "Phone 6",
                field: "phone6",
                width: "125px",
            },
        ],

        studentUrl: "",

        studentColumns: [
            {
                sortable: false,
                label: "Student ID",
                field: "studentID",
                hidden: false,
            },
            {
                sortable: true,
                label: "Name",
                field: "studentName",
                hidden: false,
            },
            {
                sortable: false,
                label: "Hebrew Name",
                field: "studentNameH",
                hidden: false,
            },
            {
                sortable: false,
                label: "Section",
                field: "section",
                hidden: false,
            },
        ],

        parentColumns: [
            {
                sortable: false,
                label: "Family ID",
                field: "familyID",
                link: "Account View",
                hidden: false,
            },
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
            },
            {
                sortable: false,
                label: "Hebrew Name",
                field: "hname",
                hidden: false,
            },
            {
                sortable: false,
                label: "Address",
                field: "address1",
                hidden: false,
            },
        ],

        dinnerColumns: [
            {
                sortable: false,
                label: "Donor ID",
                field: "personID",
                link: "DinnerAccountView",
                hidden: false,
            },
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
            },
            {
                sortable: false,
                label: "Hebrew Name",
                field: "nameH",
                hidden: false,
            },
            {
                sortable: false,
                label: "Address",
                field: "address1",
                hidden: false,
            },
        ],

        staffUrl: "",

        staffColumns: [
            {
                sortable: false,
                label: "Teacher Code",
                field: "teacherCode",
                hidden: false,
            },
            {
                sortable: false,
                label: "Teacher",
                field: "teacherH",
                hidden: false,
            },
            {
                sortable: true,
                label: "Class",
                field: "class",
                hidden: false,
            },
            {
                sortable: false,
                label: "Section",
                field: "section",
                hidden: false,
            },
            {
                sortable: false,
                label: "Branch",
                field: "branch",
                hidden: false,
            },
            {
                sortable: false,
                label: "Phone",
                field: "alertPhone",
                hidden: false,
            },
            {
                sortable: false,
                label: "Type",
                field: "type",
                hidden: false,
            },
        ],
    }),
    watch: {
        async loadPhoneNumbers(value) {
            await this.loadNumbers();
        },
        async loadTransferPhoneNumbers(value) {
            await this.loadTransferNumbers();
        },
    },
    async created() {
        this.setBroadcastTime();

        this.loadNumbers();
        this.loadTransferNumbers();
        this.loadGradesList();
        this.loadAudioLibrary();
        this.loadBroadcasts();
        this.loadTerms();
        this.loadRegID();

        this.addNumber();

        const settings = await this.getAwsSettings();

        this.awsPolly = new AWS.Polly({
            accessKeyId: settings.accessKey,
            secretAccessKey: settings.secretKey,
            region: "us-east-1",
        });

        //this.subscribeToPusher();
    },
    beforeDestroy() {
        //this.pusher.unsubscribe("broadcast");
    },
    computed: {
        allNumbersSelected: {
            get() {
                return (
                    this.numbers.length && this.numbers.every((s) => s.selected)
                );
            },
            set(select) {
                this.numbersToDisplay.forEach((s) => (s.selected = select));
                this.numbers.forEach((s) => (s.selected = select));
            },
        },
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(this.numbers.length / this.pagination.rowsPerPage)
                : 0;
        },
    },
    methods: {
        async getAwsSettings() {
            const response = await this.$http.get(
                "api/adminPortal/GetAwsPollyCredentials",
            );

            return response;
        },
        setBroadcastTime() {
            const broadcastTime = moment().toDate();
            const currentTime = broadcastTime.getTime();
            const updatedTime = new Date(currentTime + 2 * 60 * 60 * 1000);

            updatedTime.setMinutes(0);

            this.broadcastTime = updatedTime;
        },
        async continueToRecipients() {
            const validations = [this.$refs.callName.validate(true)];

            if (this.broadcastType == "CALL") {
                validations.push(this.$refs.fromNumberText.validate(true));
            } else {
                if (!this.from || !this.from.number) {
                    this.$notify({
                        text: "Please Select the Caller ID",
                        group: "notification",
                        type: "error",
                    });

                    return;
                }
            }

            if (!validations.every(Boolean)) return;

            this.stepper = 2;

            this.loadStudentsGrid();
        },
        continueToAudio() {
            if (!this.numbers.length) {
                this.$notify({
                    text: "Please add numbers",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (this.broadcastType == "CALL" && this.shouldMerge) {
                this.plivoInstructions = [
                    {
                        audioURL: "",
                        dataField: "",
                        text: "",
                        type: "Audio",
                    },
                ];
            }

            this.stepper = 3;
        },
        validateCallMerge() {
            if (this.broadcastType != "CALL" || !this.shouldMerge) return;

            // const validations = this.plivoInstructions.map(
            //     (instruction, index) => {
            //         if (instruction.type == "Data Field")
            //             return this.$refs.dateField[index].validate(true);
            //         if (instruction.type == "Audio")
            //             return this.$refs.audioURL[index].validate(true);
            //         if (instruction.type == "Text") {
            //             console.log(this.$refs);
            //             return this.$refs.callText[index].validate(true);
            //         }
            //     }
            // );

            const dataFieldValidations = this.plivoInstructions
                .filter((i) => i.type == "Data Field")
                .map((instruction, index) => {
                    console.log(this.$refs.dataField[index]);
                    return this.$refs.dataField[index].validate(true);
                });

            const audioValidations = this.plivoInstructions
                .filter((i) => i.type == "Audio")
                .map((instruction, index) => {
                    return this.$refs.audioURL[index].validate(true);
                });

            const textValidations = this.plivoInstructions
                .filter((i) => i.type == "Text")
                .map((instruction, index) => {
                    return this.$refs.callText[index].validate(true);
                });

            const validations = [
                ...dataFieldValidations,
                ...audioValidations,
                ...textValidations,
            ];

            return validations.every(Boolean)
                ? ""
                : "Please fill in the required fields";
        },
        continueToReview() {
            if (
                !this.audioFile &&
                this.broadcastType == "CALL" &&
                !this.shouldMerge
            ) {
                this.$notify({
                    text: "Please choose an audio file",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            const callMergeError = this.validateCallMerge();

            if (callMergeError) {
                this.$notify({
                    text: callMergeError,
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (this.$refs.message && !this.$refs.message.validate(true))
                return;

            if (
                !this.message &&
                this.broadcastType == "TEXT" &&
                !this.shouldMerge
            ) {
                this.$notify({
                    text: "Message Required",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (
                this.broadcastType == "TEXT" &&
                this.shouldMerge &&
                !this.mergeMessage
            ) {
                this.$notify({
                    text: "Message Required",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            this.stepper = 4;
        },
        getPhoneTypes() {
            if (this.broadcastType == "TEXT") return ["CEL", "MCEL"];

            return ["CEL", "MCEL", "PHON"];
        },
        async loadNumbers(value = null) {
            this.loadingNumbers = true;

            const filter = value
                ? `$filter=contains(number, '${value}') or contains(description, '${value}')`
                : "";

            const url = getDomain() + `/odata/broadcast?${filter}`;

            const response = await this.$http.get(url);

            this.loadingNumbers = false;

            this.fromNumbers = response.value.map((number) => {
                number.displayNumber = `${this.formatPhoneNumber(
                    number.number,
                )} (${number.description}${
                    number.emails ? " - " + number.emails : ""
                })`;

                return number;
            });

            if (!this.fromNumber) {
                this.from = this.fromNumbers.find(
                    (t) => t.number == "19299550923",
                );
                this.fromNumber = "19299550923";
            }
        },
        getNumberList() {
            return this.carrier == "TWILIO"
                ? this.fromNumbers.filter((n) => n.verifiedByTwilio)
                : this.fromNumbers;
        },
        async loadTransferNumbers(value = null) {
            this.loadingTransferNumbers = true;

            const filter = value
                ? `$filter=contains(number, '${value}') or contains(description, '${value}')`
                : "";

            const url = getDomain() + `/odata/broadcast?${filter}`;

            const response = await this.$http.get(url);

            this.loadingTransferNumbers = false;

            this.transferNumbers = response.value.map((number) => {
                number.displayNumber = `${this.formatPhoneNumber(
                    number.number,
                )} (${number.description}${
                    number.emails ? " - " + number.emails : ""
                })`;

                return number;
            });

            if (!this.transferNumber) {
                this.transferNumberSelect = this.transferNumbers.find(
                    (t) => t.number == "17189639261",
                );
                this.transferNumber = "17189639261";
            }
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        async loadTerms() {
            this.terms = await this.$http.get("api/allStudents/getRegTerms");
        },
        async loadBranchList() {
            let grade = this.grade
                ? this.grade.filter((b) => this.gradeList.includes(b))
                : "";

            grade = grade ? grade.join(",") : "";

            const branches = await this.$http.get(
                "api/students/getBranchList?grades=" + grade,
            );

            this.branchList = branches.sort();
            this.branchList.unshift("Select All");

            if (
                this.$store.state.authentication.branch &&
                !this.$store.state.authentication.branch.includes("null")
            ) {
                this.branchList = [this.$store.state.authentication.branch];
                this.branch = [this.$store.state.authentication.branch];
                this.staffBranch = [this.$store.state.authentication.branch];
            }
        },
        getMessageCount(value) {
            if (!value) return 0;

            let count = 0;
            for (let i = 0; i < value.length; i++) {
                let code = value.charCodeAt(i);
                if (code < 128) {
                    count++;
                } else if (code < 2048) {
                    count += 2;
                } else if (code < 65536) {
                    count += 3;
                } else {
                    count += 4;
                }
            }

            return count;
        },
        branchChanged(value) {
            if (value.includes("Select All")) {
                value = this.branchList.filter((g) => g != "Select All");
                this.branch = value;
            }

            const branch = value ? value.join(",") : "";

            localStorage.setItem("broadcast-call-branch", branch);

            this.reloadStudents();

            this.loadGradesList();
        },
        staffBranchChanged(value) {
            if (value.includes("Select All")) {
                value = this.branchList.filter((g) => g != "Select All");
                this.staffBranch = value;
            }

            const branch = value ? value.join(",") : "";

            localStorage.setItem("broadcast-call-branch", branch);

            this.staffUrl = "teachers?branch=" + value.join(",") + "&grade=";

            this.$refs.staffGrid.load(this.staffUrl);
        },
        disableBranch() {
            if (!this.$store.state.authentication.branch) return false;

            return (
                this.$store.state.authentication.branch &&
                !this.$store.state.authentication.branch.includes("null")
            );
        },
        async loadGradesList() {
            let branch = this.branch
                ? this.branch.filter((b) => this.branchList.includes(b))
                : "";

            branch = branch ? branch.join(",") : "";

            const grades = await this.$http.get(
                "api/students/getGradeList?branch=" + branch,
            );

            this.gradeList = grades.sort();
            this.gradeList.unshift("Select All");
        },
        disableChooseNumberAction(action) {
            if (action == "studentList")
                return (
                    (this.shouldMerge && this.mergeType == "file") ||
                    this.source == "dinner"
                );
            if (action == "uploadFromFile")
                return this.shouldMerge && this.mergeType == "account";
            if (action == "manualEntry")
                return this.shouldMerge && this.mergeType == "file";
            if (action == "importAccounts")
                return this.shouldMerge && this.mergeType == "file";
        },
        openChooseNumberDialog(mode) {
            this.selectNumberMode = mode;
            this.chooseNumbersDialog = true;
        },
        accountIDsEnterted(text) {
            const accountIDs = text.replace(" ", "").split(/[\n,]/);

            this.accountIDs = accountIDs.map((a) =>
                a
                    .replace("/", "")
                    .replace("\n", "")
                    .toUpperCase(),
            );
        },
        gradesChanged(value) {
            if (value.includes("Select All")) {
                value = this.gradeList.filter((g) => g != "Select All");
                this.grade = value;
            }

            this.reloadStudents();

            this.loadBranchList();
        },
        termsChanged(value) {
            this.regID = value;

            this.reloadStudents();

            this.loadBranchList();
            this.loadGradesList();
        },
        async beforeSetupGrid() {
            await this.loadBranchList();

            this.loadGradesList();

            this.studentUrl =
                "allStudents?branch=&grade=&section=&regID=" + this.regID;

            this.staffUrl =
                "teachers?" +
                (this.staffBranch.length
                    ? "branch=" + this.staffBranch.join(",") + "&grade="
                    : "branch=&grade=");
        },
        loadStudentsGrid() {
            if (!this.$refs.grid) return;

            this.reloadStudents();
        },
        reloadStudents() {
            if (this.regID == "RG2023") {
                this.studentUrl =
                    "students?branch=" +
                    this.branch.join(",") +
                    "&grade=" +
                    this.grade.join(",") +
                    "&section=";
            } else {
                this.studentUrl =
                    "studentsNewYear?branch=" +
                    this.branch.join(",") +
                    "&grade=" +
                    this.grade.join(",") +
                    "&section=";
            }

            this.$refs.grid.load(this.studentUrl);

            if (this.$refs.parentGrid) {
                this.$refs.parentGrid.load(this.studentUrl);
            }
        },
        getStudentsTitle() {
            if (!this.$refs.grid) return "Students (0)";

            return this.$refs.grid.getTitle();
        },
        getParentsTitle() {
            if (!this.$refs.parentGrid) return "Parents (0)";

            return "Parents" + this.$refs.parentGrid.getTitle().split(" ")[1];
        },
        async onStudentsLoaded(students) {
            this.loadNumberCount();
        },
        async loadNumberCount() {
            const response = await this.$refs.grid.loadAll();

            // if (
            //     (this.branch.length || this.grade.length) &&
            //     response.length > 10000
            // ) {
            //     this.loadStudentsGrid();

            //     return;
            // }

            this.students = response;
            this.studentCount = response.length;

            const group = groupBy(response, "familyID");

            this.parentCount = Object.keys(group).length;

            this.showParentsTable = true;

            const numbersCount = await this.$http.post(
                "api/broadcast/getNumbersCount?",
                Object.keys(group),
            );

            this.numbersCount = numbersCount;
        },
        studentListMapper(students) {
            const group = groupBy(students, "familyID");

            return Object.keys(group).map((key) => {
                const family = group[key];

                return {
                    familyID: key,
                    name: family[0].name,
                    hname: family[0].hname,
                    address1: family[0].address1,
                };
            });
        },
        carrierChanged(value) {
            this.from = this.fromNumbers.find((t) => t.number == "19299550923");
            this.fromNumber = "19299550923";
        },
        broadcastTypeChanged(value) {
            if (value == "TEXT") {
                this.carrier = "PLIVO";
                this.from = this.fromNumbers.find(
                    (t) => t.number == "18775447264",
                );
                this.fromNumber = "18775447264";
            } else {
                this.from = this.fromNumbers.find(
                    (t) => t.number == "19299550923",
                );
                this.fromNumber = "19299550923";
            }

            if (value == "TEXT") {
                this.broadcastList = this.broadcasts
                    .filter((draft) => draft.text)
                    .map((b) => b.id + " - " + b.name);
            } else {
                this.broadcastList = this.broadcasts
                    .filter((draft) => !draft.text)
                    .map((b) => b.id + " - " + b.name);
            }
        },
        setPagianation() {
            if (this.getSkip() >= this.numbers.length) return;

            const number =
                (this.pagination.page - 1) * this.pagination.rowsPerPage;

            this.numbersToDisplay = this.numbers.slice(
                number,
                number + this.pagination.rowsPerPage,
            );
        },
        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.numbers.length) {
                skip = this.numbers.length - this.pagination.rowsPerPage;
            }

            return skip;
        },
        async openAudioLibrary() {
            await this.loadAudioLibrary();

            this.audioLibraryDialog = true;
        },
        async loadBroadcasts() {
            this.broadcasts = await this.$http.get(
                "api/broadcast/getBroadcasts",
            );

            this.broadcastList = this.broadcasts
                .filter((draft) => !draft.text)
                .map((b) => b.id + " - " + b.name);
        },
        async loadDraft(id, isCopy = false) {
            if (!id) {
                this.callName = "";
                this.broadcastID = "";

                return;
            }

            console.log(id);

            const broadcastResponse = await this.$http.get(
                `api/broadcast/getByID?id=` + id,
            );

            const broadcast = broadcastResponse;

            // const broadcast = this.broadcasts.find((b) => b.id == +id);

            if (!broadcast) return "";

            this.broadcastID = isCopy ? "" : broadcast.id;
            this.callName = isCopy ? "" : broadcast.name;
            this.callSpeed = broadcast.callSpeed
                ? broadcast.callSpeed.toString()
                : "MAX";
            this.broadcastType = broadcast.text ? "TEXT" : "CALL";

            this.fromNumberTextChanged(broadcast.callerID);
            this.fromNumber = broadcast.callerID;
            this.message = broadcast.text;
            this.source = broadcast.accountsSource
                ? broadcast.accountsSource.toLowerCase()
                : "tuition";

            if (broadcast.transferNumber) {
                this.shouldTransfer = true;

                this.transferNumber = broadcast.transferNumber;
                this.transferNumberTextChanged(broadcast.transferNumber);
            } else {
                this.shouldTransfer = false;
            }

            const response = await this.$http.get(
                "api/broadcast/getBroadcastDraft?broadcastID=" + broadcast.id,
            );

            if (broadcast.isDraft) {
                this.numbers = response.numbers.map((number) => ({
                    accountID: number.accountID,
                    number: number.number,
                    name: number.name,
                    nameH: number.nameH,
                }));
            } else {
                this.numbers = this.getBroadcastNumbers(response);
            }

            this.numbersToDisplay = this.numbers.slice(0, 13);

            if (broadcast.audioID) {
                const audio = this.audioLibrary.find(
                    (a) => a.id == broadcast.audioID,
                );

                audio.selected = true;

                this.selectedAudio = audio;
                this.audioFile = audio.recordingURL;
            }
        },
        getBroadcastNumbers(response) {
            if (response.broadcast.text) {
                return response.sms.map((message) => ({
                    accountID: message.accountId,
                    number: message.to,
                    name: message.name,
                    nameH: message.nameH,
                }));
            } else {
                return response.calls.map((call) => ({
                    accountID: call.accountID,
                    number: call.to,
                    name: call.name,
                    nameH: call.nameH,
                }));
            }
        },
        async loadAudioLibrary() {
            this.loadingAudio = true;

            const audioLibrary = await this.$http.get(
                "api/broadcast/getAudioLibrary",
            );

            this.audioLibrary = audioLibrary
                .map((audio) => {
                    audio.selected = false;
                    audio.editing = false;
                    audio.name = audio.name ? audio.name : "Unnamed";

                    return audio;
                })
                .filter((audio) => {
                    // if (
                    //     this.$store.state.authentication.branch &&
                    //     !this.$store.state.authentication.branch.includes(
                    //         "null"
                    //     )
                    // ) {
                    //     return (
                    //         audio.branch ==
                    //         this.$store.state.authentication.branch
                    //     );
                    // }

                    return true;
                });

            this.loadingAudio = false;
        },
        editAudio(audio) {
            audio.editing = true;
            audio.originalName = audio.name;
        },
        cancelAudioName(audio) {
            audio.name = audio.originalName;
            audio.editing = false;
        },
        async saveAudioName(audio) {
            audio.editing = false;

            await this.$http.post(
                "api/broadcast/updateAudioName?id=" +
                    audio.id +
                    "&name=" +
                    audio.name,
            );

            this.loadAudioLibrary();
        },
        openDeleteAudioDialog(audio) {
            this.audioToDelete = audio;

            this.deleteAudioDialog = true;
        },
        async deleteAudio() {
            this.deleting = true;

            await this.$http.post(
                "api/broadcast/deleteAudio?id=" + this.audioToDelete.id,
            );

            this.deleting = false;
            this.deleteAudioDialog = false;

            this.loadAudioLibrary();
        },
        selectAudio(audio) {
            this.audioLibrary
                .filter((a) => a.recordingURL != audio.recordingURL)
                .forEach((a) => (a.selected = false));

            audio.selected = true;

            this.selectedAudio = audio;
            this.audioFile = audio.recordingURL;

            this.audioLibraryDialog = false;
        },
        notifyError(text) {
            this.$notify({
                text: text,
                group: "notification",
                type: "error",
            });
        },
        async addNumbers() {
            if (this.selectNumberMode == "studentList") {
                if (!this.$refs.branch.validate(true)) return;

                if (!this.phoneTypes.length) {
                    return this.notifyError("Please Select a phone type");
                }

                if (!this.students.length) {
                    return this.notifyError("No accounts to notify");
                }

                this.addingNumbers = true;

                const data = await this.$refs.grid.loadAll();

                const response = await this.$http.post(
                    "api/broadcast/loadNumbers",
                    {
                        accountIDs: data.map((d) => d.accountID),
                        source: this.source,
                    },
                );

                const numbers = response.numbers.filter(
                    (n) => this.phoneTypes.includes(n.phoneType) && n.phoneNum,
                );

                numbers.forEach((n) => {
                    const number = n.phoneNum.replaceAll("-", "");

                    if (this.numbers.some((sn) => sn.number == number)) return;

                    this.numbers.push({
                        accountID: n.accountID,
                        name: n.name,
                        nameH: n.nameH,
                        number: number,
                        selected: false,
                    });
                });
            } else if (this.selectNumberMode == "importAccounts") {
                if (!this.accountIDs) {
                    return this.notifyError(
                        "Please enter a list of a Account ID's",
                    );
                }

                this.addingNumbers = true;

                const response = await this.$http.post(
                    "api/broadcast/loadNumbers",
                    { accountIDs: this.accountIDs, source: this.source },
                );

                const numbers = response.numbers.filter(
                    (n) => this.phoneTypes.includes(n.phoneType) && n.phoneNum,
                );

                numbers.forEach((n) => {
                    const number = n.phoneNum.replaceAll("-", "");

                    if (this.numbers.some((sn) => sn.number == number)) return;

                    this.numbers.push({
                        accountID: n.accountID,
                        name: n.name,
                        nameH: n.nameH,
                        number: number,
                        selected: false,
                    });
                });
            } else if (this.selectNumberMode == "manualEntry") {
                const numbers = this.manualNumbers.filter((n, index) => {
                    return (
                        n.number &&
                        this.$refs.manualNumber[index].validate(true)
                    );
                });

                if (!numbers.length) {
                    return this.notifyError(
                        this.manualNumbers.filter((n) => n.number).length
                            ? "No Valid Numbers Entered"
                            : "No Numbers Entered",
                    );
                }

                if (this.isMergingFromFile()) return;

                const response = await this.$http.post(
                    "api/broadcast/loadAccounts",
                    {
                        accountIDs: numbers.map((a) => a.accountID),
                        source: this.source,
                    },
                );

                numbers.forEach((n) => {
                    const number = n.number.replaceAll("-", "");

                    if (this.numbers.some((sn) => sn.number == number)) return;

                    const account = response.accounts.find(
                        (a) =>
                            a.accountID ==
                            (n.accountID ? n.accountID.toUpperCase() : ""),
                    );

                    this.numbers.push({
                        accountID: n.accountID ? n.accountID.toUpperCase() : "",
                        name: account ? account.name : "",
                        nameH: account ? account.nameH : "",
                        number: number,
                        selected: false,
                    });
                });
            } else if (this.selectNumberMode == "staffList") {
                this.addingNumbers = true;

                const data = await this.$refs.staffGrid.loadAll();

                data.forEach((teacher) => {
                    if (!teacher.alertPhone || teacher.alertPhone.length < 10)
                        return;

                    if (
                        this.numbers.some(
                            (sn) => sn.number == teacher.alertPhone,
                        )
                    )
                        return;

                    this.numbers.push({
                        teacherCode: teacher.teacherCode,
                        name: teacher.teacher,
                        nameH: teacher.teacherH,
                        number: teacher.alertPhone,
                        selected: false,
                    });
                });
            } else {
                const numbers = this.to.filter((n) => n.number && !n.error);

                if (!numbers.length) {
                    return this.notifyError(
                        "Please upload a list of valid numbers",
                    );
                }

                const response = await this.$http.post(
                    "api/broadcast/loadAccounts",
                    {
                        accountIDs: numbers.map((a) => a.accountID),
                        source: this.source,
                    },
                );

                numbers.forEach((n) => {
                    const number = n.number.replaceAll("-", "");

                    if (
                        this.numbers.some((sn) => {
                            if (!sn.number) return false;

                            return sn.number.replaceAll("-", "") == number;
                        })
                    )
                        return;

                    const account = response.accounts.find(
                        (a) => a.accountID == n.accountID,
                    );

                    this.numbers.push({
                        accountID: n.accountID,
                        name: account ? account.name : "",
                        nameH: account ? account.nameH : "",
                        number: number,
                        selected: false,
                    });
                });

                this.toNumbers = [];
            }

            await this.loadAccountInfo();

            this.addingNumbers = false;
            this.chooseNumbersDialog = false;
            this.numbersToDisplay = this.numbers.slice(0, 13);
        },
        async loadAccountInfo() {
            if (this.isMergingFromFile() || !this.shouldMerge) return;

            try {
                this.addingNumbers = true;

                const accountData = await this.$http.post(
                    "api/broadcast/loadAccountInfo?",
                    {
                        accountIDs: this.numbers.map((n) => n.accountID),
                        source: this.source,
                    },
                );

                this.numbers.forEach((number) => {
                    number.data = accountData.find(
                        (a) =>
                            a.accountID == number.accountID ||
                            a.personID == number.accountID,
                    );
                });

                this.addingNumbers = false;
            } catch (e) {
                this.notifyError("Error Loading Account Information");

                this.addingNumbers = false;
            }
        },
        isMergingFromFile() {
            return this.shouldMerge && this.mergeType == "file";
        },
        sourceChanged(value) {
            this.clearNumbers();
        },
        getMergeFields() {
            if (!this.numbers.length) return [];

            const data = this.numbers[0].data;

            if (!data) return [];

            return Object.keys(data)
                .map((d) => toTitleCase(d))
                .sort();
        },
        onMergeFieldSelected(value) {
            const insertText = value;
            if (!insertText || !insertText.length) return;

            const textarea = this.$refs.mergeMessage.$refs.input;
            const sentence = textarea.value;
            const len = sentence.length;
            let pos = textarea.selectionStart;

            if (pos === undefined) {
                pos = 0;
            }

            const before = sentence.substr(0, pos);
            const after = sentence.substr(pos, len);

            this.mergeMessage = before + "<<" + insertText + ">>" + after;
        },
        addInstruction(type, index) {
            if (type == "call") {
                this.plivoInstructions.splice(index + 1, 0, {
                    audioURL: "",
                    dataField: "",
                    text: "",
                    type: "Audio",
                });
            } else {
                this.plivoInstructions.splice(index + 1, 0, {
                    dataField: "",
                    text: "",
                    type: "Text",
                });
            }

            this.$forceUpdate();
        },
        removeInstruction(type, index) {
            if (type == "call") {
                this.plivoInstructions.splice(index, 1);
            } else {
                this.plivoInstructions.splice(index, 1);
            }

            this.$forceUpdate();
        },
        onTypeChange(instruction) {
            instruction.dataField = "";
            instruction.audioURL = "";
            instruction.text = "";
        },
        playText(text) {
            let params = {
                OutputFormat: "mp3",
                Text: text,
                TextType: "text",
                VoiceId: "Joanna",
            };

            this.awsPolly.synthesizeSpeech(params, (err, data) => {
                const uInt8Array = new Uint8Array(data.AudioStream);
                const arrayBuffer = uInt8Array.buffer;
                const blob = new Blob([arrayBuffer]);
                const url = URL.createObjectURL(blob);
                console.log(url);
                var audio = new Audio(url);
                audio.play();
            });
        },
        clearNumbers() {
            this.numbers = [];
            this.numbersToDisplay = [];
            this.manualNumbers = [
                {
                    accountID: "",
                    number: "",
                },
            ];
            this.accountIDsText = "";
        },
        addNumber() {
            this.manualNumbers.push({
                accountID: "",
                number: "",
            });

            this.$forceUpdate();
        },
        removeNumber(index) {
            this.manualNumbers.splice(index, 1);

            this.$forceUpdate();
        },
        getTotalCalls() {
            return this.numbers.length;

            if (this.selectNumberMode == "uploadFromFile") {
                return this.to.filter((n) => n.number && !n.error).length;
            } else if (this.selectNumberMode == "manualEntry") {
                const numbers = this.manualNumbers.filter((n, index) => {
                    return (
                        n.number &&
                        this.$refs.manualNumber[index] &&
                        this.$refs.manualNumber[index].validate(true)
                    );
                });

                return numbers.length;
            }

            if (!this.numbersCount) return;

            let total = 0;

            this.phoneTypes.forEach((type) => {
                total += +this.numbersCount[type.toLowerCase()];
            });

            return total;
        },
        pickNumbersFile(transaction) {
            this.$refs.numbersFile.click();
        },
        async onNumbersFilePicked(e) {
            if (!e.target.files) return;

            this.uploadingNumbers = true;

            if (this.isMergingFromFile()) {
                await this.onMergeFilePicked(e);

                this.toNumbers = this.numbers.map((number) => {
                    number.phone1 = number.number;

                    return number;
                });

                this.to = this.numbers;

                this.uploadingNumbers = false;

                return;
            }

            this.fileReader(e.target.files[0]);
        },
        pickMergeFile() {
            this.$refs.mergeFiles.click();
        },
        async onMergeFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                this.mergeFiles = files;

                formData.append("upload_file", this.mergeFiles[0]);

                const response = await this.$http.post(
                    "api/broadcast/importMergeFile?",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.numbers = response.data.map((line) => {
                    return {
                        accountID: line.accountID,
                        number: line.number,
                        name: line.name,
                        nameH: line.nameH,
                        data: line,
                        // data: except(
                        //     line,
                        //     "accountID",
                        //     "number",
                        //     "name",
                        //     "nameH",
                        // ),
                    };
                });

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        fileReader(file) {
            Papa.parse(file, {
                complete: (data) => this.fileParser(data),
            });
        },
        fileParser(file) {
            if (!file.data || !file.data.length) {
                this.$notify({
                    text: "No numbers found",
                    group: "notification",
                    type: "error",
                });

                this.uploadingNumbers = false;

                return;
            }

            const numbers = this.mapPhoneNumbers(file.data);

            this.handleDuplicates(numbers);

            if (numbers.length) {
                this.to = numbers;

                const group = groupBy(numbers, "lineNumber");

                this.toNumbers = Object.keys(group).map((key) => {
                    const numbers = group[key];

                    return {
                        accountID: numbers[0] ? numbers[0].accountID : "",
                        phone1: numbers[0] ? numbers[0].number : "",
                        phone2: numbers[1] ? numbers[1].number : "",
                        phone3: numbers[2] ? numbers[2].number : "",
                        phone4: numbers[3] ? numbers[3].number : "",
                        phone5: numbers[4] ? numbers[4].number : "",
                        phone6: numbers[5] ? numbers[5].number : "",
                        error1: numbers[0] ? numbers[0].error : "",
                        error2: numbers[1] ? numbers[1].error : "",
                        error3: numbers[2] ? numbers[2].error : "",
                        error4: numbers[3] ? numbers[3].error : "",
                        error5: numbers[4] ? numbers[4].error : "",
                        error6: numbers[5] ? numbers[5].error : "",
                    };
                });

                this.uploadingNumbers = false;

                return;
            }

            this.$notify({
                text: "Please upload a file with valid phone numbers",
                group: "notification",
                type: "error",
            });

            this.uploadingNumbers = false;
        },
        mapPhoneNumbers(data) {
            const lines = data
                .filter((line) => line.some(Boolean))
                .map((line, index) => this.mapLine(line, index));

            return [].concat.apply([], lines);
        },
        mapLine(line, index) {
            const accountID = line[0] ? line[0].toUpperCase() : "";

            return line.slice(1, 7).map((value) => {
                const data = {
                    lineNumber: index,
                    accountID,
                };

                if (!value) return data;

                let number = value.replace(/[-() ]/g, "");

                if (!/^\d+$/.test(number)) {
                    data.error = "Must be only digits";
                    data.number = number;

                    return data;
                }

                if (number.length < 10) {
                    data.error = "Must be 10 digits";
                    data.number = number;

                    return data;
                }

                data.number = this.formatPhoneNumber(number);

                return data;
            });
        },
        formatPhoneNumber(number) {
            const value =
                number.length > 10
                    ? number.substring(number.length - 10)
                    : number;

            return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        },
        fromNumberChanged(value) {
            this.fromNumber = value.number;
        },
        fromNumberTextChanged(value) {
            const fromNumber = this.fromNumbers.find((n) => n.number == value);

            if (fromNumber) {
                this.from = fromNumber;
            } else {
                this.from = null;
            }
        },
        transferNumberChanged(value) {
            this.transferNumber = value.number;
        },
        transferNumberTextChanged(value) {
            const number = this.transferNumbers.find((n) => n.number == value);

            if (number) {
                this.transferNumberSelect = number;
            } else {
                this.transferNumberSelect = null;
            }
        },
        handleDuplicates(numbers) {
            const valid = [];

            numbers
                .filter((n) => !n.error && n.number)
                .forEach((number, index) => {
                    const duplicates = numbers.filter(
                        (n) => n.number == number.number,
                    );

                    if (
                        duplicates.length == 1 ||
                        !valid.some((v) => v == number.number)
                    ) {
                        valid.push(number.number);

                        return;
                    }

                    number.error = "Duplicate";
                });
        },
        removeDuplicates(numbers) {
            return numbers.filter((value, index) => {
                const _value = JSON.stringify(value);
                return (
                    index ===
                    numbers.findIndex((obj) => {
                        return JSON.stringify(obj) === _value;
                    })
                );
            });
        },
        getError(row, field) {
            if (field == "accountID") return;

            const errorField = "error" + field.substring(field.length - 1);

            return row[errorField];
        },
        cancel() {
            this.$router.push({
                name: "Students",
            });
        },
        async saveDraft() {
            await this.$http.post("api/broadcast/saveBroadcastDraft", {
                broadcastID: this.broadcastID ? this.broadcastID : 0,
                from: this.fromNumber,
                user: this.$store.state.authentication.user,
                //types: this.phoneTypes,
                audioID:
                    this.broadcastType == "TEXT" ? null : this.selectedAudio.id,
                broadcastName: this.callName,
                text: this.broadcastType == "TEXT" ? this.message : null,
                transferNumber: this.shouldTransfer
                    ? this.transferNumber
                    : null,
                callSpeed:
                    this.callSpeed && this.callSpeed != "MAX"
                        ? this.callSpeed
                        : null,
                numbers: this.numbers,
                repeat: 2,
                //branch: this.branch.join(","),
                //grade: this.grade.join(","),
                //numberSelectionMode: this.selectNumberMode,
            });

            this.reset();

            this.close("draft");
        },
        getSelectedCount() {
            if (!this.$refs.grid || !this.$refs.grid.getSelectedRowsData())
                return;

            return this.$refs.grid.getSelectedRowsData().length;
        },
        getSelectedFamilyCount() {
            if (!this.$refs.grid) return 0;

            const group = groupBy(
                this.$refs.grid.getSelectedRowsData(),
                "familyID",
            );

            return Object.keys(group).length;
        },
        sendCall() {
            if (!this.validate()) return;

            if (!this.audioFile) {
                this.$notify({
                    text: "Missing Audio File",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (
                this.selectNumberMode == "studentList" &&
                !this.students.length
            ) {
                this.$notify({
                    text: "No accounts to notify",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            this.confirmDialog = true;
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                this.files = files;

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/broadcast/uploadAudioFile?user=" +
                        this.$store.state.authentication.user,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.audioFile = response.url;
                this.selectedAudio = response.audio;

                this.uploading = false;

                this.loadAudioLibrary();
            } catch (e) {
                this.uploading = false;
            }
        },
        validate() {
            const validations = [
                this.$refs.fromNumberText.validate(true),
                this.$refs.callName.validate(true),
            ];

            if (this.selectNumberMode == "studentList") {
                validations.push(
                    this.$refs.broadcastCallPhoneTypes.validate(true),
                );
            }

            return validations.every(Boolean);
        },
        callRequest({ isTest, accountIDs }) {
            const domain = window.location.origin.startsWith("http://localhost")
                ? "https://localhost:7197/"
                : "https://broadcast-3t6ck5zrrq-ue.a.run.app/";

            const url =
                this.broadcastType == "TEXT"
                    ? domain + "broadcast/broadcastMessage"
                    : domain + "broadcast/broadcastCall";

            return this.$http.post(url, {
                requestID: this.requestID,
                from: this.fromNumber,
                user: this.$store.state.authentication.user,
                types: this.phoneTypes,
                audioFile: this.broadcastType == "TEXT" ? null : this.audioFile,
                audioID:
                    this.broadcastType == "TEXT" ? null : this.selectedAudio.id,
                broadcastID: this.broadcastID ? this.broadcastID : null,
                broadcastName: this.callName,
                repeat: 2,
                isTest: isTest,
                testNumber: this.testNumber,
                text: this.broadcastType == "TEXT" ? this.message : null,
                transferNumber: this.shouldTransfer
                    ? this.transferNumber
                    : null,
                callSpeed:
                    this.callSpeed && this.callSpeed != "MAX"
                        ? this.callSpeed
                        : null,
                //accountIDs,
                numbers: this.getNumbers(),
                branch: this.branch.join(","),
                grade: this.grade.join(","),
                numberSelectionMode: this.selectNumberMode,
                isMerging: this.shouldMerge,
                accountsSource: this.source,
                broadcastTime: this.getBroadcastTime(),
                carrier: this.carrier,
            });
        },
        getBroadcastTime() {
            if (!this.isSchedule && this.getNumbers().length > 100) {
                return moment().format("YYYY-MM-DD HH:mm:ss");
            }

            if (!this.isSchedule) return null;

            const time = moment(this.broadcastTime).format("HH:mm");

            const date = moment(this.broadcastDate).toDate();

            return moment(
                new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate(),
                    time.split(":")[0],
                    time.split(":")[1],
                ),
            ).format("YYYY-MM-DD HH:mm:ss");
        },
        getNumbers() {
            if (this.broadcastType == "TEXT" && this.shouldMerge) {
                return this.numbers.map((number) => {
                    number.text = this.getMergedText(number);
                    number.plivoCallInstructions = this.getCallInstructions(
                        number,
                    );

                    return number;
                });
            }

            if (this.broadcastType == "CALL" && this.shouldMerge) {
                return this.numbers.map((number) => {
                    number.plivoCallInstructions = this.getCallInstructions(
                        number,
                    );

                    return number;
                });
            }

            return this.numbers;
        },
        showMergeTextButton(action) {
            if (action == "next") {
                return this.numbers.length - 1 != this.mergeTextIndex;
            } else {
                return this.mergeTextIndex != 0;
            }
        },
        updateMergeSampleText(action) {
            if (action == "next") {
                this.mergeTextIndex = ++this.mergeTextIndex;
            } else {
                this.mergeTextIndex = --this.mergeTextIndex;
            }
        },
        getMergedText(number) {
            if (!number || !number.data) return;

            let text = this.mergeMessage;
            const mergeFields = [];
            const rxp = /<<([^>>]+)>>/g;
            let curMatch = "";

            while ((curMatch = rxp.exec(text))) {
                mergeFields.push(curMatch[1]);
            }

            mergeFields.forEach((field) => {
                let value = number.data[firstToLower(field)];

                if (!value) {
                    value = number.data[field];
                }

                if (value === undefined) return;

                text = text.replaceAll("<<" + field + ">>", value);
            });

            return text;
        },
        getCallInstructions(number) {
            if (this.broadcastType == "TEXT" || !this.shouldMerge) return [];

            const callInstructions = this.plivoInstructions.map(
                (instruction) => {
                    const callInstruction = {
                        audioURL: instruction.audioURL,
                        type: instruction.type,
                        date: moment().format("YYYY-MM-DD HH:mm:ss"),
                        user: this.$store.state.authentication.user,
                    };

                    if (instruction.text) {
                        callInstruction.text = instruction.text + " ";
                    } else if (instruction.dataField) {
                        const field = !this.isMergingFromFile()
                            ? instruction.dataField.charAt(0).toLowerCase() +
                              instruction.dataField.slice(1)
                            : instruction.dataField;

                        callInstruction.text = number.data[field] + " ";
                    }

                    return callInstruction;
                },
            );

            return callInstructions;
        },
        async send(isTest = false) {
            if (!this.$refs.testNumber.validate(true)) return;

            this.requestID = Math.floor(Math.random() * 10000000);

            let selected = [];
            let accountIDs = [];

            if (this.selectNumberMode == "studentList") {
                selected = this.students;

                accountIDs = selected.map((s) => s.familyID);
            }

            try {
                if (isTest) {
                    this.broadcastID = await this.callRequest({
                        isTest,
                        accountIDs,
                    });
                } else {
                    this.sending = true;

                    this.callRequest({ isTest, accountIDs });
                }

                if (!isTest) {
                    this.sending = false;

                    // if (
                    //     this.broadcastType == "CALL" &&
                    //     (!this.callSpeed || this.callSpeed == "MAX")
                    // ) {
                    //     this.openSnakbar(this.requestID);
                    // }

                    this.closeDialog("active");

                    this.reset();
                } else {
                    this.$notify({
                        text: "Test call sent",
                        group: "notification",
                        type: "success",
                    });
                }
            } catch (e) {
                console.log(e);
                this.sending = false;
            }
        },
        close(activeTab = null) {
            this.closeDialog(activeTab);

            this.reset();
        },
        openConfirmCloseDialog() {},
        confirmClose() {
            this.confirmCloseDialog = false;

            this.closeDialog();

            this.reset();
        },
        reset() {
            this.stepper = 1;
            this.from = "";
            this.source = "tuition";
            this.broadcastID = "";
            this.to = [];
            this.message = "";
            this.mergeMessage = "";
            this.fromNumber = "";
            this.testNumber = "";
            this.fromNumbers = [];
            this.transferNumbers = [];
            this.transferNumber = "";
            this.transferNumberSelect = "";
            this.accountIDsText = "";
            this.callSpeed = "MAX";
            this.broadcastType = "CALL";
            this.files = [];
            this.phoneTypes = [];
            this.audioFile = "";
            this.selectedAudio = "";
            this.callName = "";
            this.carrier = "";
            this.studentListTab = "students";
            this.manualNumbers = [];
            this.accountIDs = [];
            this.numbers = [];
            this.numbersToDisplay = [];
            this.toNumbers = [];
            this.branchList = [];
            this.grade = [];
            this.gradeList = [];
            this.branch = [];
            this.students = [];
            this.shouldTransfer = "";
            this.mergeFiles = [];
            this.mergeType = "file";
            this.numbersCount = "";
            this.studentCount = 0;
            this.parentCount = 0;
            this.mergeTextIndex = 0;
            this.shouldMerge = false;
            this.selectNumberMode = "studentList";
            this.broadcastTime = new Date();
            this.broadcastDate = toISOLocal(new Date(moment())).substr(0, 10);

            this.setBroadcastTime();

            this.loadBranchList();
            this.loadGradesList();
            this.addNumber();
        },
    },
};
</script>
<style>
.number-list table.vgt-table td {
    padding: 0.5em 0.75em 0.5em 0.75em !important;
}
.number-list table.vgt-table {
    font-size: 15px !important;
}
.number-list .vgt-responsive {
    overflow-x: unset;
}
.student-list.container {
    padding-left: 0px !important;
    padding-right: 0px !important;
}
.student-list .v-card {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
        0 0 0 0 rgba(0, 0, 0, 0.12) !important;
}
.big-button {
    padding: 0 10px !important;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 14px !important;
}
.big-button .v-btn__content {
    padding: 0 10px !important;
    line-height: 48px;
}
.button-toggle-override {
    border-radius: 5px;
    overflow: hidden;
}
.button-toggle-override.v-btn-toggle .v-btn:not(:last-child) {
    border: none !important;
}
.button-toggle-override.v-btn-toggle .v-btn.v-btn--active {
    font-weight: 500 !important;
    background-color: #4caf50 !important;
    color: #fff;
}
.button-toggle-override.theme--light.v-btn-toggle .v-btn {
    background-color: #a8e8a4;
    opacity: 1;
    color: #fff;
    font-weight: 500 !important;
}
.selected-tab {
    color: rgb(76, 175, 80) !important;
    border-bottom: 1px solid rgb(76, 175, 80) !important;
}
.merge-text {
    border: 1px solid black;
    border-radius: 3px;
    height: 250px;
    overflow-y: auto;
    white-space: pre-line !important;
}
.time-list .dx-texteditor.dx-state-focused.dx-editor-outlined {
    border-color: #30a635 !important;
}
.time-list .dx-texteditor.dx-state-hover {
    border-color: #30a635 !important;
}
</style>
